<template>
    <div class="login-wrap">
      <el-form :rules="rules"  ref="formInline" label-width="80px" :model="formInline"  class="login-container">
        <h1 class="title">用户注册</h1>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="用户信息" name="first">
              <el-form-item prop="loginName" label="登录名称">
                  <el-input type="text" v-model="formInline.loginName"  placeholder="登录名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="loginPassword1" label="登录密码">
                  <el-input type="password" v-model="formInline.loginPassword1" placeholder="登录密码" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="loginPassword2" label="登录密码">
                  <el-input type="password" v-model="formInline.loginPassword2" placeholder="确认登录密码" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="trueName" label="用户姓名">
                  <el-input type="text" v-model="formInline.trueName" placeholder="用户姓名" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="mobilePhone" label="注册手机">
                  <el-input type="text" v-model="formInline.mobilePhone" placeholder="注册手机" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="shopUserRemark" label="备注">
                  <el-input type="textarea" v-model="formInline.shopUserRemark" placeholder="备注" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="nextClick()" style="width: 100%;">下一步</el-button>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="商家信息" name="shop">
              <el-form-item prop="orgName" label="商家名称">
                  <el-input type="text" v-model="formInline.orgName"  placeholder="商家名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="loginName" label="商家分类">
                  <el-cascader
                      v-model="formInline.orgCategoryGuid"
                      :options="orgCategoryList">
                  </el-cascader>
                  <!-- <el-select style="width: 100%;" v-model="formInline.barrelGuid" placeholder="商家分类">
                    <el-option v-for="item in wineBarrelList" :key="item.id" :label="item.barrelName" :value="item.guid"></el-option>
                    <el-option label="分类名称" value="1"></el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item label="店铺区域" prop="cityAreaGuid">
                      <el-cascader :props="props" style="color: #000;" placeholder="店铺区域" v-model="formInline.cityAreaGuid" ref="cascader" @change="bindChangeCity"></el-cascader>
                </el-form-item>
                <el-form-item prop="legalPerson" label="法人姓名">
                  <el-input type="text" v-model="formInline.legalPerson" placeholder="法人姓名" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="legalMobile" label="法人电话">
                  <el-input type="text" v-model="formInline.legalMobile" placeholder="法人电话" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="orgAddress" label="店铺地址">
                  <el-input type="text" v-model="formInline.orgAddress" placeholder="店铺地址" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="营业执照" prop="licenseImage">
                        <el-upload
                            action="1"
                            list-type="picture-card"
                            accept="image/*"
                            :multiple="false"
                            :auto-upload="false"
                            :limit="1"
                            :on-change="onLicenseImageChange"
                            :on-remove="handleLicenseImageRemove">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="doLogin('formInline')" style="width: 100%;">注册</el-button>
              </el-form-item>
            </el-tab-pane>

          </el-tabs>
        
      </el-form>
  </div>
</template>

<script>
import Base64 from '../utils/base64'
import cityApi from '../api/cityManage/city' 
import loginApi from '../api/login' 
export default {
  name: 'register',
  data () {
    const _this = this;
    var validatePhone = (rule, value, callback) => {
        const reg = /^1[3-9]\d{9}$/;
        if (value === '') {
          callback(new Error('手机号码不能为空'));
        } else if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号码'));
        } else {
          callback();
        }
    }
    return {
        activeName: 'first',
        licenseImage: null,
        orgCategoryList: [],
        formInline:{
          loginName: '',
            loginPassword1: '',
            loginPassword2: '',
            orgCategoryGuid: '',
            trueName: '',
            mobilePhone: '',
            shopUserRemark: '',
            orgName: '',
            cityAreaGuid: '',
            legalPerson: '',
            legalMobile: '',
            orgAddress: '',
            licenseImage: ''
        },
        
        rules: {
          loginName: [
                { required: true, message: '请输入登录名称', trigger: 'blur' }
            ],
            loginPassword1: [
                { required: true, message: '请输入密码', trigger: 'blur' }
            ],
            loginPassword2: [
                { required: true, message: '请输入确认密码', trigger: 'blur' }
            ],
            mobilePhone: [
                { required: true, validator: validatePhone, trigger: 'blur' }
            ],
            orgName: [
                { required: true, message: '请输入商家名称', trigger: 'blur' }
            ],
            legalPerson: [
                { required: true, message: '请输入法人姓名', trigger: 'blur' }
            ],
            legalMobile: [
                { required: true, validator: validatePhone, trigger: 'blur' }
            ],
            orgAddress: [
                { required: true, message: '请输入店铺地址', trigger: 'blur' }
            ],
            cityAreaGuid: [
                { required: true, message: '请选择区域', trigger: 'blur' }
            ],
            orgCategoryGuid: [
                { required: true, message: '请选择商户分类', trigger: 'blur' }
            ],
            licenseImage: [
                { required: true, message: '请选择营业执照', trigger: 'blur' }
            ],
        },
        props: {
          lazy: true,
          lazyLoad (node, resolve) {
              const { level } = node;
              if(level == 0){
                  _this.queryProvince(node,resolve);
              }else if(level == 1){
                  _this.provinceCode = node.value;
                  _this.queryCity(node,resolve);
              }else if(level == 2){
                  _this.queryCounty(node,resolve);
              }
              
          }
      }
    }
  },
  created(){
   
    this.queryBusOrgCategoryByParentId()
  },
  methods: {
    handleClick(){

    },
    // 查询机构分类
    queryBusOrgCategoryByParentId(){
      loginApi.queryBusOrgCategoryByParentId({
            id: 0
        }).then(res =>{
            if(res.code == 0){
                this.orgCategoryList = this.orgCategoryEach(res.data);
            }else{
                Message({message: '错误提示：'+res.msg,type: 'error'});
            }
        })
    },
    orgCategoryEach(list){
      list.forEach(item =>{
        item.label = item.categoryName;
        item.value = item.guid
        if(item.children != null){
          this.orgCategoryEach(item.children);
        }
      });
      return list
    },
    onLicenseImageChange(e){
      this.licenseImage = e.raw;
      this.formInline.licenseImage = e.raw;
    },
    handleLicenseImageRemove(){
      this.licenseImage = null;
      this.formInline.licenseImage = '';
    },
     // 选择城市
     bindChangeCity(e){
        let getCheckedNodes = this.$refs.cascader.getCheckedNodes()[0];
        this.formInline.cityAreaGuid = getCheckedNodes.data.value;
    },    
    queryProvince(node,resolve){
          // 查询省
          cityApi.queryProvince().then(res =>{
            // console.log(res)
            if(res.code == 0){
                let nodes = res.data.map(item => ({
                    value: item.provinceCode,
                    label: item.provinceName,
                    leaf: false
                }));
                resolve(nodes);
            }else{
                Message({message: '错误提示：'+res.msg,type: 'error'});
            }
        });
    },
    queryCity(node,resolve){
        // 查询市
        cityApi.queryCity({provinceCode: node.value}).then(res =>{
            if(res.code == 0){
                let nodes = res.data.map(item => ({
                    value: item.cityCode,
                    label: item.cityName,
                    leaf: false
                }));
                resolve(nodes);
            }else{
                Message({message: '错误提示：'+res.msg,type: 'error'});
            }
        });
    },
    queryCounty(node,resolve){
        // 区县
        cityApi.queryCounty({provinceCode: this.provinceCode,cityCode: node.value}).then(res =>{
            if(res.code == 0){
                let nodes = res.data.map(item => ({
                    value: item.guid,
                    label: item.countyName,
                    leaf: true
                }));
                resolve(nodes);
            }else{
                Message({message: '错误提示：'+res.msg,type: 'error'});
            }
        });
    },
    nextClick(formName){
        this.activeName = 'shop';            
    },
    doLogin(formName){
        let _this = this;
        this.$refs[formName].validate((valid) => {
            if (valid) {
              _this.checkLoginName();
            }else{
                return false;
            } 
        })
    },
    checkLoginName(){   
        let _this = this; 
        loginApi.checkLoginName({
          loginName: this.formInline.loginName
        }).then(res =>{
            // console.log(res)
            if(res.code == 0){
              _this.register();
            }else{
              // console.log(11111)
              this.$message.error(res.msg);
            }
        })
    },
    register(){    
        loginApi.register(this.organizationFormData()).then(res =>{
            // console.log(res)
            if(res.code == 0){
              this.$message.success('注册成功');
              this.$router.push({path: '/login'}).catch((res) =>{});
            }else{
              this.$message.error(res.msg);
            }
        })
    },
    
    //  组织formData
    organizationFormData(){
        // console.log(1111)
        let formData = new FormData();
        formData.append('licenseImageFile', this.licenseImage);
        let objectJson = this.formInline;
            Object.keys(objectJson).forEach(function (key) {
                if(key == 'licenseImage'){
                  // console.log(11)
                }else if(objectJson[key] == 'null' || objectJson[key] == null){
                    formData.append(key, '');
                }else{
                    formData.append(key, objectJson[key]);
                }                        
            });
        return formData
    },
  }
}
</script>

<style scoped>
    .login-wrap {
      background-image: url('../assets/busWineDeviceBag.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
  		box-sizing: border-box;
  		width: 100%;
  		height: 100vh;
  		padding-top: 3%;
  		/* background-color: #112346; */
  		background-repeat: no-repeat;
  		background-position: center right;
  		background-size: 100%;
  	}
    .el-input{
      width: 80%;
    }
 
  	.login-container {
  		border-radius: 10px;
  		margin: 0px auto;
  		width: 450px;
  		padding: 30px 35px 15px 35px;
  		background: #fff;
  		border: 1px solid #eaeaea;
  		text-align: left;
  		box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  	}
 
  	.title {
  		margin: 0px auto 40px auto;
  		text-align: center;
  		color: #505458;
  	}
</style>


// WEBPACK FOOTER //
// src/views/register.vue